module.exports = __webpack_public_path__ + "img/ElectricChargingStationV2.e0ef3861.png";